<template>
  <Dialog v-model:open="open">
    <DialogContent class="md:min-w-[570px]">
      <DialogHeader>
        <DialogTitle>Share project with others</DialogTitle>
      </DialogHeader>
      <div class="p-5">
        <Protect :permissions="[SYS_PERMISSIONS.SYS_MEMBERSHIPS_MANAGE]">
          <InviteExternalUser />
        </Protect>
        <template v-if="isParticipant">
          <PeopleOverview />
          <PendingInvitation />
          <hr class="border-[#3E4546] mb-4" />
        </template>
        <AccessConfiguration />
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import {
  Dialog,
  DialogHeader,
  DialogContent,
  DialogTitle,
} from '@ui/components/dialog';
import Protect from '@/hoc/Protect.vue';
import { SYS_PERMISSIONS } from '@/constants.js';
import InviteExternalUser from './InviteExternalUser.vue';
import PeopleOverview from './PeopleOverview.vue';
import PendingInvitation from './PendingInvitation.vue';
import AccessConfiguration from './AccessConfiguration.vue';

const open = defineModel('open', { type: Boolean, default: false });
const store = useStore();

const isParticipant = computed(
  () => store.getters['project/users/amIParticipant']
);
</script>
